import "../../styles/layout.scss";
import { Home, ChatBubbleOutline, Gavel, AccountBalance, Menu } from '@mui/icons-material';
import { Chat } from "../Chat";
import { NotificationsList } from "../NotificationsList";
import { useRef, useState, useEffect, use } from "react";
import { useUnit } from "effector-react";
import { $pushNotifications } from "../../store/pushNotifications";
import { $chatMessages, $isAuth, $userData } from "../../store";
import { VerticalIconButton } from "../VerticalIconButton";
import { MenuElement } from "./MenuElement";
import { FloatingTabsPanel } from "../FloatingTabsPanel";
import { $unreadAnnouncementsCount } from "../../store";

export const Footer = () => {
    const [unreadMessages, setUnreadMessages] = useState({
        messages: 0,
        notifications: 0
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const buttonRef = useRef(null);

    const messages = useUnit($chatMessages);
    const userData = useUnit($userData);
    const isAuth = useUnit($isAuth);
    const pushNotifications = useUnit($pushNotifications);
    const unreadAnnouncementsCount = useUnit($unreadAnnouncementsCount);

    useEffect(() => {
        const unreadMessages = messages.filter(message => !message.read && message.senderId !== userData.id && message.recipientId === userData.id).length;
        const unreadNotifications = pushNotifications.filter(notification => !notification.isRead).length;
        setUnreadMessages({
            messages: unreadMessages,
            notifications: unreadNotifications
        });
    }, [messages, pushNotifications, userData]);

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const goToMain = () => {
        window.location.href = '/';
    };

    const openPanel = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }

        setIsPanelOpen(true);
    };

    const goToCurrentBiddings = () => {
        window.location.href = "/currentBiddings";
    };

    const goToSubscriptionPay = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=/payment`;
            return;
        }
        window.location.href = `/payment`;
    }

    return (
        <div className="layout__footer">
            <div className="layout__footer__menu">
                <VerticalIconButton
                    icon={<Home />}
                    label="Главная"
                    onClick={goToMain}
                    badgeContent={unreadAnnouncementsCount} />
                <VerticalIconButton
                    icon={<ChatBubbleOutline />}
                    label="Чат"
                    badgeContent={unreadMessages.messages + unreadMessages.notifications}
                    onClick={() => openPanel()}
                    ref={buttonRef}
                />

                <VerticalIconButton icon={<Gavel />} label="Торги" onClick={goToCurrentBiddings} />
                <VerticalIconButton icon={<AccountBalance />} label="Оплата" onClick={goToSubscriptionPay} />
                <VerticalIconButton icon={<Menu />} label="Меню" onClick={openMenu} />
                <MenuElement anchor={anchorEl} setAnchor={setAnchorEl} />
            </div>
            <FloatingTabsPanel
                isOpen={isPanelOpen}
                onClose={() => setIsPanelOpen(false)}
                anchorEl={buttonRef.current}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                    {
                        id: 'chat',
                        label: 'Чат',
                        icon: '💬',
                        component: Chat,
                        unreadCount: unreadMessages.messages
                    },
                    {
                        id: 'notifications',
                        label: 'Уведомления',
                        icon: '🔔',
                        component: NotificationsList,
                        unreadCount: unreadMessages.notifications
                    }
                ]}
            />
        </div>
    )
}